export const sumAmounts = (amounts: number[]) =>
  amounts.reduce((cents, amount) => cents + Math.round(amount * 100), 0) / 100;

export const formatAmount = (amount: number, currency = 'PLN') =>
  `${amount.toLocaleString('pl-PL', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })} ${currency}`;
